export default "__VITE_ASSET__D$TqZu3i__"